/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_Signal_ProductsInputs */

const en_directory_builders_signal_products = /** @type {(inputs: Directory_Builders_Signal_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products`)
};

const zh_directory_builders_signal_products = /** @type {(inputs: Directory_Builders_Signal_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品数`)
};

/**
* | output |
* | --- |
* | "Products" |
*
* @param {Directory_Builders_Signal_ProductsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_signal_products = /** @type {((inputs?: Directory_Builders_Signal_ProductsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_Signal_ProductsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_signal_products(inputs)
	return zh_directory_builders_signal_products(inputs)
});
export { directory_builders_signal_products as "directory.builders.signal_products" }